var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29396 4.60891L7.16418 1.73158C7.18653 1.70917 7.20425 1.68257 7.21633 1.65331C7.22841 1.62405 7.2346 1.5927 7.23456 1.56104C7.23452 1.52939 7.22824 1.49805 7.21609 1.46882C7.20394 1.43959 7.18615 1.41304 7.16374 1.39069C7.14132 1.36834 7.11473 1.35062 7.08547 1.33854C7.05621 1.32647 7.02485 1.32027 6.9932 1.32031C6.96154 1.32035 6.93021 1.32663 6.90098 1.33878C6.87175 1.35093 6.8452 1.36872 6.82285 1.39114L4.12329 4.0978L1.42374 1.39114C1.37859 1.34587 1.31731 1.3204 1.25338 1.32031C1.18945 1.32023 1.12811 1.34554 1.08285 1.39069C1.03758 1.43584 1.01211 1.49711 1.01202 1.56104C1.01194 1.62497 1.03726 1.68632 1.0824 1.73158L3.95262 4.60891C3.975 4.63138 4.0016 4.64921 4.03089 4.66137C4.06018 4.67354 4.09158 4.6798 4.12329 4.6798C4.155 4.6798 4.1864 4.67354 4.21569 4.66137C4.24498 4.64921 4.27158 4.63138 4.29396 4.60891Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.44a38891.svg";
export { ForwardRef as ReactComponent };